import FirebaseEventManager from "../firebaseEventManager";

export default class MobileNotsupportPageEventManager extends FirebaseEventManager {
  constructor(platform) {
    super();
    this.platform = platform;
  }

  sendLandedEvent() {
    const eventName =
      this.platform === "webviewer"
        ? "grt_webviewermobile_landed"
        : "grt_webcameramobile_landed";
    this.firebase.analytics().logEvent(eventName, {});
  }

  sendShareBtnClickEvent() {
    const eventName =
      this.platform === "webviewer"
        ? "grt_webviewermobileshare_clicked"
        : "grt_webcameramobileshare_clicked";
    this.firebase.analytics().logEvent(eventName, {});
  }

  sendAppLinkClickEvent() {
    const eventName =
      this.platform === "webviewer"
        ? "grt_webviewermobileapp_clicked"
        : "grt_webcameramobileapp_clicked";
    this.firebase.analytics().logEvent(eventName, {});
  }
}
